import { render, staticRenderFns } from "./fixed.vue?vue&type=template&id=817aef72"
import script from "./fixed.vue?vue&type=script&lang=js"
export * from "./fixed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports